import { apiClient } from './client.tsx';
import { BatchConfirmParkingBillingRequest } from './requests/batch-confirm-parking-billing-request.ts';

export const fetchUnconfirmedBillings = () =>
  apiClient
    .get(
      '/maas_billing/parking_billings?states=PENDING,READY,INITIALIZED,CALCULATED',
    )
    .then((res) => res.data.data);

export const fetchConfirmedBillings = () =>
  apiClient
    .get('/maas_billing/parking_billings?states=CONFIRMED')
    .then((res) => res.data.data);

export const fetchHistoryBillings = (request) =>
  apiClient
    .get('/maas_billing/parking_billings?states=ARCHIVED', {
      params: request,
    })
    .then((res) => res.data.data);

export const confirmBill = (id: string) =>
  apiClient
    .post(`/maas_billing/parking_billings/${id}/confirm`)
    .then((res) => res.data.data);

export const batchConfirmBillings = (data: BatchConfirmParkingBillingRequest) =>
  apiClient
    .post(`/maas_billing/parking_billings/batch_confirm`, data)
    .then((res) => res.data.data);

export const voidBill = (id: string) =>
  apiClient
    .delete(`/maas_billing/parking_billings/${id}`)
    .then((res) => res.data.data);

export const fetchBillReportUrl = (id: string) =>
  apiClient
    .get(`/maas_billing/parking_billings/${id}/statement_report_url`)
    .then((res) => res.data.data.url);
